// Global game state management
export const gameState = {
    // Game settings
    playerCount: 1,         // 1 or 2
    difficulty: 'normal',   // 'easy', 'normal', 'hard'

    // Level progress
    currentLevel: 1,
    isGameStarted: false,
    isPaused: false,

    // Entities
    players: [],            // Array of player entities
    boss: null,
    minions: [],

    // Boss AI state
    bossState: 'idle',
    bossTimer: 0,
    bossChargeTarget: null,

    // Minion spawning
    minionSpawnTimer: 0,

    // Laser beam
    laserBeam: null,
    laserTarget: null,
    laserChargeEffect: null,

    // Arena
    arenaEntities: [],
    collisionObjects: [],

    // Camera shake
    shakeOffset: { x: 0, y: 0 },
    shakeIntensity: 0,

    // Core references
    app: null,
    camera: null,
    keyboard: null,
    audioCtx: null
};

// Reset game state for new game
export function resetGameState() {
    gameState.currentLevel = 1;
    gameState.isGameStarted = false;
    gameState.isPaused = false;
    gameState.players = [];
    gameState.boss = null;
    gameState.minions = [];
    gameState.bossState = 'idle';
    gameState.bossTimer = 0;
    gameState.bossChargeTarget = null;
    gameState.minionSpawnTimer = 0;
    gameState.laserBeam = null;
    gameState.laserTarget = null;
    gameState.laserChargeEffect = null;
    gameState.arenaEntities = [];
    gameState.collisionObjects = [];
    gameState.shakeOffset = { x: 0, y: 0 };
    gameState.shakeIntensity = 0;
}

// Set player count
export function setPlayerCount(count) {
    gameState.playerCount = Math.max(1, Math.min(2, count));
}

// Set difficulty
export function setDifficulty(difficulty) {
    if (['easy', 'normal', 'hard'].includes(difficulty)) {
        gameState.difficulty = difficulty;
    }
}

// Get current level config with difficulty applied
export function getCurrentConfig() {
    return {
        level: gameState.currentLevel,
        difficulty: gameState.difficulty,
        playerCount: gameState.playerCount
    };
}
